export default class tid {
  constructor() {
    var t = this;
    this.tick();

    if(!window.studiotime){
      window.studiotime = setInterval(function(){
        t.tick();
      }, 950);
    }
  }

  tick() {
    let d = new Date(new Date().toLocaleString("en-US", {timeZone: "Europe/Stockholm"}));
    let h = parseInt(d.getHours()) < 10 ? '0'+d.getHours() : d.getHours();
    let min = parseInt(d.getMinutes()) < 10 ? '0'+d.getMinutes() : d.getMinutes();
    let sec = parseInt(d.getSeconds()) < 10 ? '0'+d.getSeconds() : d.getSeconds();
    var time = h + ":" + min + ":" + sec;
    $('.tid--tick').text(time);
  }
}
